import { render, staticRenderFns } from "./RegistrationsClear.vue?vue&type=template&id=c5a0726e&scoped=true"
import script from "./RegistrationsClear.vue?vue&type=script&lang=js"
export * from "./RegistrationsClear.vue?vue&type=script&lang=js"
import style0 from "./RegistrationsClear.vue?vue&type=style&index=0&id=c5a0726e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a0726e",
  null
  
)

export default component.exports